var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAtivo4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 397 421.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:url(#linear-gradient-2);}.cls-4{fill:url(#linear-gradient-3);}.cls-5{fill:url(#linear-gradient-4);}.cls-6{fill:url(#linear-gradient-5);}.cls-7{fill:url(#linear-gradient-6);}.cls-8{fill:url(#linear-gradient-7);}.cls-9{fill:url(#linear-gradient-8);}.cls-10{fill:url(#linear-gradient-9);}.cls-11{fill:url(#linear-gradient-10);}.cls-12{fill:url(#linear-gradient-11);}.cls-13{fill:url(#linear-gradient-12);}.cls-14{fill:url(#linear-gradient-13);}.cls-15{fill:url(#linear-gradient-14);}.cls-16{fill:url(#linear-gradient-15);}.cls-17{fill:url(#linear-gradient-16);}.cls-18{fill:url(#linear-gradient-17);}.cls-19{fill:url(#linear-gradient-18);}.cls-20{fill:url(#linear-gradient-19);}.cls-21{fill:url(#linear-gradient-20);}.cls-22{fill:url(#linear-gradient-21);}.cls-23{fill:url(#linear-gradient-22);}.cls-24{fill:url(#linear-gradient-23);}.cls-25{fill:url(#linear-gradient-24);}.cls-26{fill:url(#linear-gradient-25);}.cls-27{fill:url(#linear-gradient-26);}.cls-28{fill:url(#linear-gradient-27);}.cls-29{fill:url(#linear-gradient-28);}.cls-30{fill:url(#linear-gradient-29);}.cls-31{fill:url(#linear-gradient-30);}.cls-32{fill:url(#linear-gradient-31);}.cls-33{fill:url(#linear-gradient-32);}.cls-34{fill:url(#linear-gradient-33);}.cls-35{fill:url(#linear-gradient-34);}.cls-36{fill:url(#linear-gradient-35);}.cls-37{fill:url(#linear-gradient-36);}.cls-38{fill:url(#linear-gradient-37);}.cls-39{fill:url(#linear-gradient-38);}.cls-40{fill:url(#linear-gradient-39);}.cls-41{fill:url(#linear-gradient-40);}.cls-42{fill:url(#linear-gradient-41);}.cls-43{fill:url(#linear-gradient-42);}.cls-44{fill:url(#linear-gradient-43);}.cls-45{fill:url(#linear-gradient-44);}.cls-46{fill:url(#linear-gradient-45);}.cls-47{fill:url(#linear-gradient-46);}.cls-48{fill:url(#linear-gradient-47);}.cls-49{fill:url(#linear-gradient-48);}.cls-50{fill:url(#linear-gradient-49);}.cls-51{fill:url(#linear-gradient-50);}.cls-52{fill:url(#linear-gradient-51);}.cls-53{fill:url(#linear-gradient-52);}.cls-54{fill:url(#linear-gradient-53);}.cls-55{fill:url(#linear-gradient-54);}.cls-56{fill:url(#linear-gradient-55);}.cls-57{fill:url(#linear-gradient-56);}.cls-58{fill:url(#linear-gradient-57);}.cls-59{fill:url(#linear-gradient-58);}.cls-60{fill:url(#linear-gradient-59);}.cls-61{fill:url(#linear-gradient-60);}.cls-62{fill:url(#linear-gradient-61);}.cls-63{fill:url(#linear-gradient-62);}.cls-64{fill:url(#linear-gradient-63);}.cls-65{fill:url(#linear-gradient-64);}.cls-66{fill:url(#linear-gradient-65);}.cls-67{fill:url(#linear-gradient-66);}.cls-68{fill:url(#linear-gradient-67);}.cls-69{fill:url(#linear-gradient-68);}.cls-70{fill:url(#linear-gradient-69);}.cls-71{fill:url(#linear-gradient-70);}.cls-72{fill:url(#linear-gradient-71);}.cls-73{fill:url(#linear-gradient-72);}.cls-74{fill:url(#linear-gradient-73);}.cls-75{fill:url(#linear-gradient-74);}.cls-76{fill:url(#linear-gradient-75);}.cls-77{fill:url(#linear-gradient-76);}.cls-78{fill:url(#linear-gradient-77);}.cls-79{fill:url(#linear-gradient-78);}.cls-80{fill:url(#linear-gradient-79);}.cls-81{fill:url(#linear-gradient-80);}.cls-82{fill:url(#linear-gradient-81);}.cls-83{fill:url(#linear-gradient-82);}.cls-84{fill:url(#linear-gradient-83);}.cls-85{fill:url(#linear-gradient-84);}.cls-86,.cls-87,.cls-88,.cls-90,.cls-93{fill:#fff;}.cls-86{opacity:0.2;}.cls-87,.cls-92,.cls-94{opacity:0.3;}.cls-88,.cls-89{opacity:0.5;}.cls-91{opacity:0.1;}.cls-91,.cls-92{mix-blend-mode:screen;}.cls-93{opacity:0.7;}.cls-95{opacity:0.6;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -1068.7,
    y1: 310.25,
    x2: -677.91,
    y2: 310.25,
    gradientTransform: "matrix(-1, 0, 0, 1, -677.91, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000032"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#252666"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -1064.52,
    y1: 322.88,
    x2: -683.71,
    y2: 274.25,
    gradientTransform: "matrix(-1, 0, 0, 1, -677.91, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#252666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#252a6a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#233577"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#21488c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#1d63a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b75bc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -868.57,
    y1: 329.21,
    x2: -774.45,
    y2: 329.21,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -861.11,
    y1: 313.38,
    x2: -775.04,
    y2: 313.38,
    gradientTransform: "matrix(-1, 0, 0, 1, -677.91, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#252666"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 337.1,
    y1: 327.3,
    x2: 354.37,
    y2: 327.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1b75bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1292a0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 321.22,
    y1: 318.13,
    x2: 338.49,
    y2: 318.13,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 305.35,
    y1: 308.97,
    x2: 322.62,
    y2: 308.97,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 289.48,
    y1: 299.81,
    x2: 306.75,
    y2: 299.81,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 273.61,
    y1: 290.64,
    x2: 290.88,
    y2: 290.64,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 257.74,
    y1: 281.48,
    x2: 275.01,
    y2: 281.48,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 241.86,
    y1: 272.31,
    x2: 259.13,
    y2: 272.31,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 225.99,
    y1: 263.15,
    x2: 243.26,
    y2: 263.15,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 210.12,
    y1: 253.98,
    x2: 227.39,
    y2: 253.98,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 194.25,
    y1: 244.82,
    x2: 211.52,
    y2: 244.82,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 178.38,
    y1: 235.65,
    x2: 195.65,
    y2: 235.65,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 162.5,
    y1: 226.49,
    x2: 179.77,
    y2: 226.49,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 146.63,
    y1: 217.32,
    x2: 163.9,
    y2: 217.32,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 130.76,
    y1: 208.16,
    x2: 148.03,
    y2: 208.16,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 314.26,
    y1: 333.34,
    x2: 342.6,
    y2: 333.34,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 292.33,
    y1: 342.23,
    x2: 325.03,
    y2: 342.23,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 97.18,
    y1: 229.56,
    x2: 129.88,
    y2: 229.56,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 267.76,
    y1: 350.36,
    x2: 307.46,
    y2: 350.36,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 79.61,
    y1: 242.27,
    x2: 121.22,
    y2: 242.27,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 118.25,
    y1: 307.07,
    x2: 230.62,
    y2: 307.07,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 275.49,
    y1: 287.66,
    x2: 318.27,
    y2: 287.66,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 196.37,
    y1: 241.97,
    x2: 239.14,
    y2: 241.97,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 297.67,
    y1: 321.91,
    x2: 319.57,
    y2: 321.91,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 355.25,
    y1: 323.77,
    x2: 363.59,
    y2: 323.77,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 347.91,
    y1: 319.53,
    x2: 356.25,
    y2: 319.53,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 340.57,
    y1: 315.29,
    x2: 348.9,
    y2: 315.29,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 333.22,
    y1: 311.05,
    x2: 341.56,
    y2: 311.05,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 325.88,
    y1: 306.81,
    x2: 334.22,
    y2: 306.81,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 318.54,
    y1: 302.57,
    x2: 326.88,
    y2: 302.57,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 267.63,
    y1: 273.18,
    x2: 275.97,
    y2: 273.18,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 260.29,
    y1: 268.94,
    x2: 268.63,
    y2: 268.94,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 252.95,
    y1: 264.7,
    x2: 261.29,
    y2: 264.7,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 245.61,
    y1: 260.46,
    x2: 253.94,
    y2: 260.46,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 238.77,
    y1: 256.51,
    x2: 247.11,
    y2: 256.51,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 177.99,
    y1: 221.42,
    x2: 186.33,
    y2: 221.42,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 185.36,
    y1: 225.68,
    x2: 193.7,
    y2: 225.68,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 170.65,
    y1: 217.18,
    x2: 178.98,
    y2: 217.18,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 163.3,
    y1: 212.94,
    x2: 171.64,
    y2: 212.94,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 155.96,
    y1: 208.7,
    x2: 164.3,
    y2: 208.7,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 148.62,
    y1: 204.46,
    x2: 156.96,
    y2: 204.46,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 141.28,
    y1: 200.22,
    x2: 149.61,
    y2: 200.22,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 274.59,
    y1: 328.79,
    x2: 296.2,
    y2: 328.79,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 258.1,
    y1: 319.26,
    x2: 279.71,
    y2: 319.26,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 241.61,
    y1: 309.74,
    x2: 263.22,
    y2: 309.74,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 225.12,
    y1: 300.22,
    x2: 246.73,
    y2: 300.22,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 208.63,
    y1: 290.7,
    x2: 230.24,
    y2: 290.7,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 192.14,
    y1: 281.18,
    x2: 213.74,
    y2: 281.18,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 175.65,
    y1: 271.66,
    x2: 197.25,
    y2: 271.66,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 159.16,
    y1: 262.14,
    x2: 180.76,
    y2: 262.14,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 142.67,
    y1: 252.61,
    x2: 164.27,
    y2: 252.61,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 126.18,
    y1: 243.09,
    x2: 147.78,
    y2: 243.09,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 248.75,
    y1: 334.23,
    x2: 270.35,
    y2: 334.23,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 266.6,
    y1: 366.52,
    x2: 288.21,
    y2: 366.52,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 247.61,
    y1: 355.56,
    x2: 269.22,
    y2: 355.56,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 228.63,
    y1: 344.59,
    x2: 250.23,
    y2: 344.59,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 98.99,
    y1: 269.74,
    x2: 120.59,
    y2: 269.74,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 80,
    y1: 258.78,
    x2: 101.61,
    y2: 258.78,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 61.01,
    y1: 247.81,
    x2: 82.62,
    y2: 247.81,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 232.26,
    y1: 324.71,
    x2: 253.86,
    y2: 324.71,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 215.76,
    y1: 315.19,
    x2: 237.37,
    y2: 315.19,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: 199.27,
    y1: 305.67,
    x2: 220.88,
    y2: 305.67,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 182.78,
    y1: 296.14,
    x2: 204.39,
    y2: 296.14,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: 166.29,
    y1: 286.62,
    x2: 187.9,
    y2: 286.62,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 149.8,
    y1: 277.1,
    x2: 171.41,
    y2: 277.1,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 133.31,
    y1: 267.58,
    x2: 154.92,
    y2: 267.58,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 116.82,
    y1: 258.06,
    x2: 138.43,
    y2: 258.06,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: 281.08,
    y1: 312.33,
    x2: 302.98,
    y2: 312.33,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: 264.49,
    y1: 302.75,
    x2: 286.39,
    y2: 302.75,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: 247.9,
    y1: 293.17,
    x2: 269.8,
    y2: 293.17,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: 231.31,
    y1: 283.59,
    x2: 253.21,
    y2: 283.59,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: 214.72,
    y1: 274.01,
    x2: 236.62,
    y2: 274.01,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: 198.13,
    y1: 264.43,
    x2: 220.03,
    y2: 264.43,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: 181.53,
    y1: 254.85,
    x2: 203.44,
    y2: 254.85,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: 164.94,
    y1: 245.27,
    x2: 186.85,
    y2: 245.27,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: 148.35,
    y1: 235.69,
    x2: 170.26,
    y2: 235.69,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: 131.76,
    y1: 226.11,
    x2: 153.67,
    y2: 226.11,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: 114.76,
    y1: 216.41,
    x2: 137.08,
    y2: 216.41,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: -1117.22,
    y1: 276.61,
    x2: -838.04,
    y2: -2.58,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: -1087.84,
    y1: 303.49,
    x2: -809.98,
    y2: 25.63,
    gradientTransform: "matrix(-1, 0, 0, 1, -677.91, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#252650"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#252854"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#233061"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#223c76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#1f4c93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#1b62b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b64bc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    x1: -1048.15,
    y1: 159.45,
    x2: -846.65,
    y2: 159.45,
    gradientTransform: "matrix(-1, 0, 0, 1, -677.91, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2b3990"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27aae1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_2",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M390.79,334.26l-141.85,81.9a39.65,39.65,0,0,1-39.67,0L8.22,300.09c-9.62-5.56-11.5-29.29-1.87-34.84l133.52-66.17c5.19-3,245.73,120.54,250.92,123.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M390.79,322.62l-141.85,81.9a39.7,39.7,0,0,1-39.67,0L8.22,288.44a14.44,14.44,0,0,1,0-25l131.65-76a16.79,16.79,0,0,1,16.79,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M186.25,345.75l-22.8,13.17a8.83,8.83,0,0,1-8.81,0l-53.69-31a8.81,8.81,0,0,1,0-15.26l22.8-13.16a8.78,8.78,0,0,1,8.81,0l53.69,31A8.81,8.81,0,0,1,186.25,345.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M97.36,316.57a9.11,9.11,0,0,1,4.33-4.25l5.41-3.05,10.77-6.17,5.38-3.08a8.71,8.71,0,0,1,8.67-.6c.88.47,1.78,1,2.67,1.54l5.38,3.09,21.54,12.34q10.74,6.19,21.57,12.27-10.68-6.32-21.41-12.55l-21.46-12.47-5.37-3.12c-.91-.51-1.77-1-2.71-1.53a9.08,9.08,0,0,0-3-.85,9.28,9.28,0,0,0-6,1.53l-5.36,3.12L107,309l-5.34,3.15A9.19,9.19,0,0,0,97.36,316.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M353.64,327.92l-9-5.19a3.84,3.84,0,0,0-3.49,0l-3.34,1.93a1.07,1.07,0,0,0,0,2l9,5.19a3.9,3.9,0,0,0,3.49,0l3.34-1.93A1.06,1.06,0,0,0,353.64,327.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M322,317.51l9,5.19a3.84,3.84,0,0,0,3.49,0l3.34-1.93a1.06,1.06,0,0,0,0-2l-9-5.19a3.84,3.84,0,0,0-3.49,0L322,315.5C321,316.05,321,317,322,317.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M321.9,309.59l-9-5.19a3.84,3.84,0,0,0-3.49,0l-3.34,1.93a1.06,1.06,0,0,0,0,2l9,5.19a3.88,3.88,0,0,0,3.48,0l3.35-1.93A1.07,1.07,0,0,0,321.9,309.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M290.2,299.18l9,5.19a3.81,3.81,0,0,0,3.48,0l3.35-1.93a1.06,1.06,0,0,0,0-2l-9-5.19a3.84,3.84,0,0,0-3.49,0l-3.35,1.93A1.06,1.06,0,0,0,290.2,299.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M290.16,291.26l-9-5.19a3.88,3.88,0,0,0-3.48,0L274.33,288a1.07,1.07,0,0,0,0,2l9,5.19a3.84,3.84,0,0,0,3.49,0l3.35-1.93A1.07,1.07,0,0,0,290.16,291.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M274.28,282.1l-9-5.19a3.84,3.84,0,0,0-3.49,0l-3.34,1.93a1.06,1.06,0,0,0,0,2l9,5.19a3.84,3.84,0,0,0,3.49,0l3.34-1.93C275.25,283.56,275.25,282.66,274.28,282.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M258.41,272.93l-9-5.19a3.9,3.9,0,0,0-3.49,0l-3.34,1.93a1.06,1.06,0,0,0,0,2l9,5.19a3.84,3.84,0,0,0,3.49,0l3.34-1.93A1.06,1.06,0,0,0,258.41,272.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M242.54,263.77l-9-5.19a3.84,3.84,0,0,0-3.49,0l-3.34,1.93c-1,.56-1,1.46,0,2l9,5.2a3.88,3.88,0,0,0,3.48,0l3.35-1.94A1.06,1.06,0,0,0,242.54,263.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M226.67,254.61l-9-5.2a3.9,3.9,0,0,0-3.49,0l-3.35,1.94a1.06,1.06,0,0,0,0,2l9,5.19a3.81,3.81,0,0,0,3.48,0l3.35-1.93A1.06,1.06,0,0,0,226.67,254.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M210.8,245.44l-9-5.19a3.81,3.81,0,0,0-3.48,0L195,242.18a1.06,1.06,0,0,0,0,2l9,5.2a3.9,3.9,0,0,0,3.49,0l3.35-1.93A1.07,1.07,0,0,0,210.8,245.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M182.44,231.08,179.1,233a1.06,1.06,0,0,0,0,2l9,5.19a3.84,3.84,0,0,0,3.49,0l3.34-1.93c1-.56,1-1.46,0-2l-9-5.2A3.9,3.9,0,0,0,182.44,231.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M179.05,227.11l-9-5.19a3.84,3.84,0,0,0-3.49,0l-3.34,1.93a1.06,1.06,0,0,0,0,2l9,5.19a3.9,3.9,0,0,0,3.49,0l3.34-1.93A1.06,1.06,0,0,0,179.05,227.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M163.18,218l-9-5.19a3.84,3.84,0,0,0-3.49,0l-3.34,1.93a1.06,1.06,0,0,0,0,2l9,5.19a3.81,3.81,0,0,0,3.48,0l3.35-1.93A1.06,1.06,0,0,0,163.18,218Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M131.48,207.54l9,5.19a3.88,3.88,0,0,0,3.48,0l3.35-1.93a1.07,1.07,0,0,0,0-2l-9-5.19a3.9,3.9,0,0,0-3.49,0l-3.35,1.93A1.07,1.07,0,0,0,131.48,207.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M341.24,333.31,328.49,326a7.25,7.25,0,0,0-6.57,0l-6.3,3.64c-1.82,1.05-1.82,2.74,0,3.79l12.74,7.36a7.25,7.25,0,0,0,6.57,0l6.31-3.64C343.05,336.05,343.05,334.35,341.24,333.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M323.67,343.45l-17.11-9.87a7.25,7.25,0,0,0-6.57,0l-6.3,3.64c-1.82,1-1.82,2.74,0,3.79l17.1,9.88a7.31,7.31,0,0,0,6.57,0l6.31-3.64C325.48,346.2,325.48,344.5,323.67,343.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M98.55,228.34l17.1,9.87a7.25,7.25,0,0,0,6.57,0l6.3-3.64c1.82-1,1.82-2.75,0-3.79l-17.1-9.88a7.25,7.25,0,0,0-6.57,0l-6.3,3.64C96.73,225.59,96.73,227.29,98.55,228.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M306.09,353.6,282,339.68a7.25,7.25,0,0,0-6.57,0l-6.3,3.64c-1.82,1.05-1.82,2.75,0,3.79L293.22,361a7.25,7.25,0,0,0,6.57,0l6.3-3.64C307.91,356.34,307.91,354.64,306.09,353.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M81,238.48l26,15a7.25,7.25,0,0,0,6.57,0l6.3-3.64c1.82-1.05,1.82-2.75,0-3.79l-26-15a7.25,7.25,0,0,0-6.57,0L81,234.69C79.16,235.73,79.16,237.43,81,238.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M229.26,331.29l-96.78-55.88a7.25,7.25,0,0,0-6.57,0l-6.3,3.64c-1.82,1.05-1.82,2.75,0,3.79l96.78,55.88a7.25,7.25,0,0,0,6.57,0l6.3-3.64C231.08,334,231.08,332.34,229.26,331.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M276,278.44l36.84,21.27a2.75,2.75,0,0,0,2.5,0l2.4-1.38a.77.77,0,0,0,0-1.45l-36.84-21.27a2.75,2.75,0,0,0-2.5,0L276,277A.76.76,0,0,0,276,278.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M196.89,232.75,233.72,254a2.78,2.78,0,0,0,2.51,0l2.4-1.38a.77.77,0,0,0,0-1.45l-36.84-21.27a2.75,2.75,0,0,0-2.5,0l-2.4,1.39A.76.76,0,0,0,196.89,232.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M299,323.8l6.3,3.64a7.25,7.25,0,0,0,6.57,0l6.31-3.64c1.81-1,1.81-2.74,0-3.79l-6.31-3.64a7.25,7.25,0,0,0-6.57,0L299,320C297.21,321.06,297.21,322.76,299,323.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M363.07,323.05l-2.4-1.39a2.75,2.75,0,0,0-2.5,0l-2.4,1.39a.76.76,0,0,0,0,1.44l2.4,1.39a2.75,2.75,0,0,0,2.5,0l2.4-1.39A.76.76,0,0,0,363.07,323.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M348.43,320.25l2.4,1.39a2.75,2.75,0,0,0,2.5,0l2.4-1.39a.76.76,0,0,0,0-1.44l-2.4-1.39a2.75,2.75,0,0,0-2.5,0l-2.4,1.39A.76.76,0,0,0,348.43,320.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M341.09,316l2.4,1.39a2.75,2.75,0,0,0,2.5,0l2.4-1.39a.76.76,0,0,0,0-1.44l-2.4-1.39a2.75,2.75,0,0,0-2.5,0l-2.4,1.39C340.39,315,340.39,315.61,341.09,316Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M333.74,311.77l2.4,1.39a2.75,2.75,0,0,0,2.5,0l2.4-1.39a.76.76,0,0,0,0-1.44l-2.4-1.39a2.82,2.82,0,0,0-2.5,0l-2.4,1.39A.76.76,0,0,0,333.74,311.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M326.4,307.53l2.4,1.39a2.75,2.75,0,0,0,2.5,0l2.4-1.39a.76.76,0,0,0,0-1.44l-2.4-1.39a2.82,2.82,0,0,0-2.5,0l-2.4,1.39A.76.76,0,0,0,326.4,307.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M319.06,303.3l2.4,1.38a2.75,2.75,0,0,0,2.5,0l2.4-1.38a.77.77,0,0,0,0-1.45l-2.4-1.38a2.75,2.75,0,0,0-2.5,0l-2.4,1.38A.77.77,0,0,0,319.06,303.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M268.15,273.9l2.4,1.39a2.75,2.75,0,0,0,2.5,0l2.4-1.39a.76.76,0,0,0,0-1.44l-2.4-1.39a2.75,2.75,0,0,0-2.5,0l-2.4,1.39A.76.76,0,0,0,268.15,273.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M260.81,269.66l2.4,1.39a2.75,2.75,0,0,0,2.5,0l2.4-1.39a.76.76,0,0,0,0-1.44l-2.4-1.39a2.75,2.75,0,0,0-2.5,0l-2.4,1.39A.76.76,0,0,0,260.81,269.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M253.47,265.42l2.4,1.39a2.75,2.75,0,0,0,2.5,0l2.4-1.39a.76.76,0,0,0,0-1.44l-2.4-1.39a2.75,2.75,0,0,0-2.5,0l-2.4,1.39A.76.76,0,0,0,253.47,265.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M246.13,261.18l2.39,1.39a2.78,2.78,0,0,0,2.51,0l2.4-1.39a.76.76,0,0,0,0-1.44l-2.4-1.39a2.78,2.78,0,0,0-2.51,0l-2.39,1.39C245.43,260.14,245.43,260.78,246.13,261.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M239.29,257.24l2.4,1.38a2.75,2.75,0,0,0,2.5,0l2.4-1.38a.77.77,0,0,0,0-1.45l-2.4-1.38a2.75,2.75,0,0,0-2.5,0l-2.4,1.38A.77.77,0,0,0,239.29,257.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M178.51,222.14l2.4,1.39a2.75,2.75,0,0,0,2.5,0l2.4-1.39a.76.76,0,0,0,0-1.44l-2.4-1.39a2.75,2.75,0,0,0-2.5,0l-2.4,1.39A.76.76,0,0,0,178.51,222.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M185.88,226.4l2.4,1.38a2.75,2.75,0,0,0,2.5,0l2.4-1.38a.77.77,0,0,0,0-1.45l-2.4-1.38a2.75,2.75,0,0,0-2.5,0l-2.4,1.38A.77.77,0,0,0,185.88,226.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M171.16,217.9l2.4,1.39a2.78,2.78,0,0,0,2.51,0l2.4-1.39a.76.76,0,0,0,0-1.44l-2.4-1.39a2.78,2.78,0,0,0-2.51,0l-2.4,1.39A.76.76,0,0,0,171.16,217.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M163.82,213.66l2.4,1.39a2.75,2.75,0,0,0,2.5,0l2.4-1.39a.76.76,0,0,0,0-1.44l-2.4-1.39a2.75,2.75,0,0,0-2.5,0l-2.4,1.39A.76.76,0,0,0,163.82,213.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M156.48,209.42l2.4,1.39a2.75,2.75,0,0,0,2.5,0l2.4-1.39a.76.76,0,0,0,0-1.44l-2.4-1.39a2.75,2.75,0,0,0-2.5,0l-2.4,1.39A.76.76,0,0,0,156.48,209.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M149.14,205.18l2.4,1.39a2.75,2.75,0,0,0,2.5,0l2.4-1.39a.76.76,0,0,0,0-1.44l-2.4-1.39a2.75,2.75,0,0,0-2.5,0l-2.4,1.39A.76.76,0,0,0,149.14,205.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M141.79,200.94l2.4,1.39a2.78,2.78,0,0,0,2.51,0l2.4-1.39a.76.76,0,0,0,0-1.44l-2.4-1.39a2.78,2.78,0,0,0-2.51,0l-2.4,1.39A.76.76,0,0,0,141.79,200.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M276.05,330.83l5.8,3.35a7.82,7.82,0,0,0,7.08,0l5.8-3.35c1.95-1.13,1.95-3,0-4.09l-5.8-3.35a7.88,7.88,0,0,0-7.08,0l-5.8,3.35C274.1,327.87,274.1,329.7,276.05,330.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M278.24,321.31c1.95-1.13,1.95-3,0-4.09l-5.8-3.35a7.82,7.82,0,0,0-7.08,0l-5.8,3.35c-1.95,1.13-1.95,3,0,4.09l5.8,3.35a7.82,7.82,0,0,0,7.08,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M243.07,311.79l5.8,3.35a7.88,7.88,0,0,0,7.08,0l5.8-3.35c1.95-1.13,1.95-3,0-4.09l-5.8-3.35a7.82,7.82,0,0,0-7.08,0l-5.8,3.35C241.12,308.83,241.12,310.66,243.07,311.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M226.58,302.26l5.8,3.35a7.82,7.82,0,0,0,7.08,0l5.8-3.35c2-1.12,2-2.95,0-4.08l-5.8-3.35a7.82,7.82,0,0,0-7.08,0l-5.8,3.35C224.63,299.31,224.63,301.14,226.58,302.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M210.09,292.74l5.8,3.35a7.82,7.82,0,0,0,7.08,0l5.8-3.35c1.95-1.12,1.95-2.95,0-4.08l-5.8-3.35a7.82,7.82,0,0,0-7.08,0l-5.8,3.35C208.14,289.79,208.14,291.62,210.09,292.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M193.6,283.22l5.8,3.35a7.82,7.82,0,0,0,7.08,0l5.8-3.35c1.95-1.13,1.95-3,0-4.08l-5.8-3.35a7.82,7.82,0,0,0-7.08,0l-5.8,3.35C191.65,280.26,191.65,282.09,193.6,283.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M177.11,273.7l5.8,3.35a7.82,7.82,0,0,0,7.08,0l5.8-3.35c2-1.13,2-3,0-4.09l-5.8-3.34a7.82,7.82,0,0,0-7.08,0l-5.8,3.34C175.16,270.74,175.16,272.57,177.11,273.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M160.62,264.18l5.8,3.35a7.82,7.82,0,0,0,7.08,0l5.8-3.35c1.95-1.13,1.95-3,0-4.09l-5.8-3.35a7.88,7.88,0,0,0-7.08,0l-5.8,3.35C158.67,261.22,158.67,263.05,160.62,264.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M144.13,254.66l5.8,3.35a7.88,7.88,0,0,0,7.08,0l5.8-3.35c1.95-1.13,1.95-3,0-4.09l-5.8-3.35a7.82,7.82,0,0,0-7.08,0l-5.8,3.35C142.18,251.7,142.18,253.53,144.13,254.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M127.64,245.14l5.8,3.35a7.88,7.88,0,0,0,7.08,0l5.8-3.35c2-1.13,2-3,0-4.09l-5.8-3.35a7.82,7.82,0,0,0-7.08,0l-5.8,3.35C125.69,242.18,125.69,244,127.64,245.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M250.21,336.27l5.8,3.35a7.82,7.82,0,0,0,7.08,0l5.8-3.35c1.95-1.13,1.95-2.95,0-4.08l-5.8-3.35a7.82,7.82,0,0,0-7.08,0l-5.8,3.35C248.26,333.32,248.26,335.14,250.21,336.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M286.74,364.48l-5.8-3.35a7.8,7.8,0,0,0-7.07,0l-5.8,3.35c-2,1.13-2,3,0,4.08l5.8,3.35a7.8,7.8,0,0,0,7.07,0l5.8-3.35C288.7,367.44,288.7,365.61,286.74,364.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M267.76,353.51l-5.8-3.34a7.82,7.82,0,0,0-7.08,0l-5.8,3.34c-2,1.13-2,3,0,4.09l5.8,3.35a7.82,7.82,0,0,0,7.08,0l5.8-3.35C269.71,356.47,269.71,354.64,267.76,353.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M248.77,342.55,243,339.2a7.82,7.82,0,0,0-7.08,0l-5.8,3.35c-2,1.13-2,3,0,4.09l5.8,3.35a7.88,7.88,0,0,0,7.08,0l5.8-3.35C250.72,345.51,250.72,343.68,248.77,342.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M119.13,267.7l-5.8-3.35a7.82,7.82,0,0,0-7.08,0l-5.8,3.35c-2,1.13-2,3,0,4.08l5.8,3.35a7.82,7.82,0,0,0,7.08,0l5.8-3.35C121.08,270.66,121.08,268.83,119.13,267.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M100.14,256.73l-5.8-3.35a7.86,7.86,0,0,0-7.07,0l-5.8,3.35c-2,1.13-2,3,0,4.09l5.8,3.35a7.8,7.8,0,0,0,7.07,0l5.8-3.35C102.1,259.69,102.1,257.86,100.14,256.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M81.15,245.77l-5.8-3.35a7.8,7.8,0,0,0-7.07,0l-5.8,3.35c-2,1.13-2,3,0,4.09l5.8,3.35a7.86,7.86,0,0,0,7.07,0l5.8-3.35C83.11,248.73,83.11,246.9,81.15,245.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M233.72,326.75l5.8,3.35a7.82,7.82,0,0,0,7.08,0l5.8-3.35c1.95-1.13,1.95-3,0-4.08l-5.8-3.35a7.82,7.82,0,0,0-7.08,0l-5.8,3.35C231.77,323.79,231.77,325.62,233.72,326.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M217.23,317.23l5.8,3.35a7.82,7.82,0,0,0,7.08,0l5.8-3.35c2-1.13,2-3,0-4.09l-5.8-3.34a7.82,7.82,0,0,0-7.08,0l-5.8,3.34C215.28,314.27,215.28,316.1,217.23,317.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M200.74,307.71l5.8,3.35a7.82,7.82,0,0,0,7.08,0l5.8-3.35c2-1.13,2-3,0-4.09l-5.8-3.35a7.88,7.88,0,0,0-7.08,0l-5.8,3.35C198.79,304.75,198.79,306.58,200.74,307.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M184.25,298.19l5.8,3.35a7.88,7.88,0,0,0,7.08,0l5.8-3.35c1.95-1.13,1.95-3,0-4.09l-5.8-3.35a7.82,7.82,0,0,0-7.08,0l-5.8,3.35C182.3,295.23,182.3,297.06,184.25,298.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M167.76,288.67l5.8,3.34a7.82,7.82,0,0,0,7.08,0l5.8-3.34c1.95-1.13,1.95-3,0-4.09l-5.8-3.35a7.82,7.82,0,0,0-7.08,0l-5.8,3.35C165.81,285.71,165.81,287.54,167.76,288.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M151.27,279.14l5.8,3.35a7.82,7.82,0,0,0,7.08,0l5.8-3.35c2-1.12,2-2.95,0-4.08l-5.8-3.35a7.82,7.82,0,0,0-7.08,0l-5.8,3.35C149.32,276.19,149.32,278,151.27,279.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M134.78,269.62l5.8,3.35a7.82,7.82,0,0,0,7.08,0l5.8-3.35c1.95-1.13,1.95-2.95,0-4.08l-5.8-3.35a7.82,7.82,0,0,0-7.08,0l-5.8,3.35C132.83,266.67,132.83,268.49,134.78,269.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M118.29,256c-2,1.12-2,3,0,4.08l5.8,3.35a7.82,7.82,0,0,0,7.08,0l5.8-3.35c1.95-1.13,1.95-3,0-4.08l-5.8-3.35a7.82,7.82,0,0,0-7.08,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M301.62,310.43l-6.31-3.64a7.25,7.25,0,0,0-6.57,0l-6.3,3.64c-1.82,1.05-1.82,2.75,0,3.79l6.3,3.64a7.25,7.25,0,0,0,6.57,0l6.31-3.64C303.43,313.18,303.43,311.48,301.62,310.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M265.85,304.64l6.3,3.64a7.25,7.25,0,0,0,6.57,0l6.31-3.64c1.81-1,1.81-2.74,0-3.79l-6.31-3.64a7.25,7.25,0,0,0-6.57,0l-6.3,3.64C264,301.9,264,303.6,265.85,304.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M268.44,291.27l-6.31-3.64a7.25,7.25,0,0,0-6.57,0l-6.3,3.64c-1.82,1.05-1.82,2.75,0,3.8l6.3,3.64a7.31,7.31,0,0,0,6.57,0l6.31-3.64C270.25,294,270.25,292.32,268.44,291.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M232.67,285.49l6.3,3.64a7.31,7.31,0,0,0,6.57,0l6.31-3.64c1.81-1.05,1.81-2.75,0-3.8l-6.31-3.64a7.25,7.25,0,0,0-6.57,0l-6.3,3.64C230.85,282.74,230.85,284.44,232.67,285.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M235.26,272.11,229,268.47a7.25,7.25,0,0,0-6.57,0l-6.3,3.64c-1.82,1.05-1.82,2.75,0,3.8l6.3,3.64a7.25,7.25,0,0,0,6.57,0l6.31-3.64C237.07,274.86,237.07,273.16,235.26,272.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M218.67,262.53l-6.31-3.64a7.31,7.31,0,0,0-6.57,0l-6.3,3.64c-1.82,1.05-1.82,2.75,0,3.8l6.3,3.64a7.25,7.25,0,0,0,6.57,0l6.31-3.64C220.48,265.28,220.48,263.58,218.67,262.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M189.2,249.31,182.9,253c-1.82,1.05-1.82,2.75,0,3.8l6.3,3.64a7.25,7.25,0,0,0,6.57,0l6.31-3.64c1.81-1.05,1.81-2.75,0-3.8l-6.31-3.64A7.31,7.31,0,0,0,189.2,249.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M185.49,243.37l-6.31-3.64a7.31,7.31,0,0,0-6.57,0l-6.3,3.64c-1.82,1-1.82,2.75,0,3.8l6.3,3.64a7.25,7.25,0,0,0,6.57,0l6.31-3.64C187.3,246.12,187.3,244.42,185.49,243.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M156,241.23a7.25,7.25,0,0,0,6.57,0l6.31-3.64c1.81-1.05,1.81-2.75,0-3.79l-6.31-3.64a7.25,7.25,0,0,0-6.57,0l-6.3,3.64c-1.82,1-1.82,2.74,0,3.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M139.43,220.58l-6.3,3.64c-1.82,1-1.82,2.74,0,3.79l6.3,3.64a7.25,7.25,0,0,0,6.57,0l6.31-3.64c1.81-1,1.81-2.75,0-3.79L146,220.58A7.25,7.25,0,0,0,139.43,220.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M116.12,218.19l6.72,3.88a7.25,7.25,0,0,0,6.57,0l6.31-3.64c1.81-1.05,1.81-2.74,0-3.79L129,210.76a7.25,7.25,0,0,0-6.57,0l-6.3,3.64C114.3,215.44,114.3,217.14,116.12,218.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M397,318.92V158.64a45.58,45.58,0,0,0-22.78-39.46L169.77,1.14C163-2.78,149,4.05,149,11.91L390.79,322.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M390.79,322.62V162.34A45.56,45.56,0,0,0,368,122.88L163.57,4.84a10.21,10.21,0,0,0-15.31,8.84v169Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-85",
    points: "370.25 287.42 370.25 147.39 168.74 31.48 168.74 171.07 370.25 287.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-86",
    points: "365.21 291.01 365.21 150.98 163.71 35.07 163.71 174.66 365.21 291.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "173.21 169.66 169.91 164.18 169.91 164.18 147.19 151.06 147.19 151.06 150.49 156.54 153.78 162.02 150.49 163.7 147.19 165.37 147.19 165.37 169.91 178.49 169.91 178.49 173.21 176.81 176.51 175.14 173.21 169.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M164.54,173.12l-2.15-1.24L162,169l-1-.56-.37,2.41-2.16-1.24,1.63-8.83,2.75,1.59Zm-2.69-5.54-.32-3.09-.29,2.74Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "199.61 184.9 196.31 179.42 196.31 179.42 173.59 166.3 173.59 166.3 176.89 171.78 180.19 177.27 176.89 178.94 173.59 180.61 173.59 180.61 196.31 193.73 196.31 193.73 199.61 192.06 202.91 190.38 199.61 184.9"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-89"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M186.43,185.76V176l2.56,1.47a6,6,0,0,1,1.59,1.34,2.6,2.6,0,0,1,.68,1.7v1.36c0,.69-.42.93-1.27.72a3,3,0,0,1,1.34,2.18v1.9c0,.64-.21,1-.64,1.08a2.35,2.35,0,0,1-1.52-.4Zm2.78-4.74v-1.66a1,1,0,0,0-.61-.87v2.7C189,181.43,189.21,181.37,189.21,181Zm0,4.57v-2.47a1,1,0,0,0-.61-.87v3.51C189,186,189.21,185.94,189.21,185.59Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "226.01 200.15 222.71 194.66 222.71 194.66 199.99 181.54 199.99 181.54 203.29 187.03 206.59 192.51 203.29 194.18 199.99 195.86 199.99 195.86 222.71 208.97 222.71 208.97 226.01 207.3 229.31 205.63 226.01 200.15"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-89"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M217.18,197.16l-2-1.14v-1.94a.48.48,0,0,0-.3-.41c-.21-.12-.31-.1-.31.06v6.78c0,.15.1.29.31.42s.3.09.3-.07v-2.41l2,1.14v2.48a.63.63,0,0,1-.69.71,2.91,2.91,0,0,1-1.56-.48c-1.67-1-2.51-2-2.51-3.21v-6.28c0-1.27.84-1.42,2.51-.46q2.25,1.31,2.25,3Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "252.41 215.39 249.12 209.91 249.12 209.91 226.39 196.79 226.39 196.79 229.69 202.27 232.99 207.75 229.69 209.43 226.39 211.1 226.39 211.1 249.12 224.22 249.12 224.22 252.41 222.54 255.71 220.87 252.41 215.39"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-89"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M238,215.52v-9.78l2.72,1.57a5.52,5.52,0,0,1,1.57,1.38,3,3,0,0,1,.7,1.86v5.91c0,.61-.22,1-.65,1a2.38,2.38,0,0,1-1.61-.42Zm2.8-.16v-6.24a1,1,0,0,0-.62-.87v7.27C240.56,215.76,240.77,215.7,240.77,215.36Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M162.6,178.75a2.33,2.33,0,0,0-1.06-1.82c-.58-.34-1-.07-1,.6a2.31,2.31,0,0,0,.7,1.54v16.51c-.41-.07-.7.2-.7.73a2.33,2.33,0,0,0,1,1.82c.58.34,1.06.07,1.06-.6a2.37,2.37,0,0,0-.71-1.55v-16.5C162.3,179.55,162.6,179.28,162.6,178.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M189.66,194.37a2.31,2.31,0,0,0-1.06-1.82c-.58-.33-1-.07-1,.6a2.34,2.34,0,0,0,.7,1.55v16.5c-.41-.07-.7.21-.7.73a2.32,2.32,0,0,0,1,1.82c.59.34,1.06.07,1.06-.6a2.32,2.32,0,0,0-.71-1.54V195.1C189.36,195.17,189.66,194.9,189.66,194.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M215.71,209.41a2.34,2.34,0,0,0-1.06-1.82c-.58-.34-1.05-.07-1.05.6a2.36,2.36,0,0,0,.7,1.55v16.5c-.41-.07-.7.2-.7.73a2.32,2.32,0,0,0,1.05,1.82c.58.34,1.06.07,1.06-.6a2.32,2.32,0,0,0-.71-1.54V210.14C215.41,210.21,215.71,209.94,215.71,209.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M240.5,241.37V224.86c.41.07.7-.2.7-.73a2.33,2.33,0,0,0-1-1.82c-.59-.34-1.06-.07-1.06.6a2.37,2.37,0,0,0,.71,1.55V241c-.41-.07-.71.2-.71.73a2.3,2.3,0,0,0,1.06,1.82c.58.34,1,.07,1-.6A2.31,2.31,0,0,0,240.5,241.37Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-91"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-90",
    points: "293.38 90.15 285.09 85.36 285.09 118.4 293.38 123.19 293.38 90.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-90",
    points: "306.53 107.18 298.24 102.39 298.24 126 306.53 130.79 306.53 107.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-90",
    points: "319.69 110.95 311.39 106.16 311.39 133.59 319.69 138.38 319.69 110.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-90",
    points: "332.84 80.88 324.55 76.09 324.55 141.19 332.84 145.97 332.84 80.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-90",
    points: "278.69 122.4 278.69 67.78 277.89 67.33 277.89 122.85 341.73 159.71 341.73 158.79 278.69 122.4"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-92"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-90",
    points: "290.99 91.7 282.7 86.91 282.7 119.95 290.99 124.74 290.99 91.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-90",
    points: "304.14 108.73 295.85 103.94 295.85 127.55 304.14 132.34 304.14 108.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-90",
    points: "317.3 112.5 309 107.72 309 135.14 317.3 139.93 317.3 112.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-90",
    points: "330.45 82.43 322.16 77.64 322.16 142.74 330.45 147.53 330.45 82.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-90",
    points: "276.3 123.95 276.3 69.33 275.51 68.88 275.51 124.4 339.34 161.26 339.34 160.35 276.3 123.95"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M220.1,308,183,286.59c-1.89-1.09-1.65-3,.53-4.26l35.78-20.65a8.19,8.19,0,0,1,7.37-.31l37.11,21.43c1.89,1.09,1.65,3-.53,4.25l-35.77,20.66C225.29,309,222,309.11,220.1,308Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M220.1,304.62,183,283.2c-1.89-1.09-1.65-3,.53-4.26l35.78-20.65a8.19,8.19,0,0,1,7.37-.31l37.11,21.43c1.89,1.09,1.65,3-.53,4.25l-35.77,20.66A8.21,8.21,0,0,1,220.1,304.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M240,287.78l-2.86-1.93a7.6,7.6,0,0,0,1.5-2.11l4.37-.19c.69,0,1.22-.36,1.22-.75l0-2.92c0-.4-.53-.73-1.22-.76l-4.38-.21a7.69,7.69,0,0,0-1.52-2.11l2.84-1.92c.44-.3.41-.75-.08-1l-3.58-2.07a2.11,2.11,0,0,0-1.79,0l-3.33,1.64a24.76,24.76,0,0,0-3.66-.88l-.35-2.52c-.06-.4-.63-.71-1.32-.71h-5c-.69,0-1.26.31-1.31.7l-.33,2.53a22.35,22.35,0,0,0-3.65.87l-3.35-1.66a2.08,2.08,0,0,0-1.79,0l-3.56,2.06c-.48.28-.51.73-.06,1l2.86,1.93a7.6,7.6,0,0,0-1.5,2.11l-4.38.19c-.68,0-1.21.36-1.21.76l0,2.91c0,.4.53.73,1.22.76l4.37.21a7.74,7.74,0,0,0,1.53,2.11l-2.84,1.92c-.45.3-.42.75.07,1l3.58,2.06a2.07,2.07,0,0,0,1.8.05l3.32-1.64a24.13,24.13,0,0,0,3.66.88l.36,2.52c0,.4.63.71,1.32.71h5c.69,0,1.26-.3,1.31-.7l.33-2.53a22.59,22.59,0,0,0,3.65-.86l3.34,1.65a2.1,2.1,0,0,0,1.8,0l3.55-2.05C240.45,288.54,240.48,288.09,240,287.78ZM216.8,285.1c-3.66-2.11-3.68-5.52,0-7.62a14.61,14.61,0,0,1,13.21,0c3.66,2.11,3.68,5.53,0,7.63A14.58,14.58,0,0,1,216.8,285.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M151.16,264,76.61,221c-1.87-1.08-1.63-3,.53-4.22l34.69-20a8.14,8.14,0,0,1,7.3-.3l74.55,43c1.87,1.08,1.64,3-.52,4.22l-34.69,20A8.16,8.16,0,0,1,151.16,264Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "182.76 243.29 112.49 202.72 115.84 200.78 186.12 241.35 182.76 243.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "175.74 247.34 105.46 206.77 108.82 204.84 179.09 245.41 175.74 247.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "168.71 251.4 98.44 210.83 101.79 208.89 172.06 249.47 168.71 251.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "161.68 255.46 91.41 214.88 94.76 212.95 165.04 253.52 161.68 255.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "154.66 259.51 84.38 218.94 87.74 217 158.01 257.58 154.66 259.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "137.13 216.94 112.49 202.72 115.84 200.78 140.48 215.01 137.13 216.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "152.13 233.72 105.46 206.77 108.82 204.84 155.49 231.78 152.13 233.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "134.17 231.46 98.44 210.83 101.79 208.89 137.53 229.52 134.17 231.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "153.34 250.64 91.41 214.88 94.76 212.95 156.69 248.7 153.34 250.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "104.87 230.77 84.38 218.94 87.74 217 108.22 228.83 104.87 230.77"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-87",
    cx: 326.04,
    cy: 252.03,
    rx: 20,
    ry: 37.53,
    transform: "translate(-48.84 80.89) rotate(-13.17)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-87",
    cx: 326.04,
    cy: 252.03,
    rx: 14.06,
    ry: 26.39,
    transform: "translate(-48.84 80.89) rotate(-13.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M332.58,263.37c-2.69,4.66-7.81,3.37-11.42-2.89s-4.36-15.12-1.67-19.79,7.81-3.37,11.43,2.89S335.28,258.7,332.58,263.37Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-88",
    points: "285.75 275.53 326.04 252.27 326.04 251.25 285.75 274.51 282.91 271.91 275.51 276.19 278.69 279.09 275.51 285.68 282.91 281.4 285.75 275.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M156.08,335.47a13.61,13.61,0,0,0-12.32,0c-3.4,1.95-3.38,5.14,0,7.11a13.63,13.63,0,0,0,12.33,0C159.51,340.62,159.49,337.44,156.08,335.47Zm-9.77,5.64c-2-1.17-2-3.05,0-4.2a8,8,0,0,1,7.27,0c2,1.17,2,3,0,4.2A8.06,8.06,0,0,1,146.31,341.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M153.58,341.12l2.54,1.46c3.39-2,3.37-5.14,0-7.11l-2.52,1.45C155.57,338.09,155.58,340,153.58,341.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M128.63,326.71c-3.39,2-3.38,5.15,0,7.12a13.61,13.61,0,0,0,12.32,0c3.39-2,3.38-5.15,0-7.12A13.61,13.61,0,0,0,128.63,326.71Zm9.82,5.67a8,8,0,0,1-7.26,0c-2-1.16-2-3,0-4.19a8,8,0,0,1,7.27,0C140.44,329.35,140.46,331.23,138.45,332.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M138.43,328.19l2.52-1.46a13.61,13.61,0,0,0-12.32,0l2.53,1.47A8,8,0,0,1,138.43,328.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M174,352.91c-3.39,2-3.37,5.15,0,7.12a13.61,13.61,0,0,0,12.32,0c3.4-2,3.38-5.14,0-7.11A13.66,13.66,0,0,0,174,352.91Zm9.83,5.68a8,8,0,0,1-7.27,0c-2-1.16-2-3,0-4.19a8,8,0,0,1,7.27,0C185.83,355.55,185.84,357.43,183.84,358.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M183.82,354.39l2.52-1.45a13.66,13.66,0,0,0-12.33,0l2.54,1.47A8,8,0,0,1,183.82,354.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M171.21,344.2a13.63,13.63,0,0,0-12.33,0c-3.39,2-3.37,5.14,0,7.11a13.6,13.6,0,0,0,12.33,0C174.64,349.36,174.62,346.17,171.21,344.2Zm-9.77,5.64c-2-1.16-2-3,0-4.2a8,8,0,0,1,7.27,0c2,1.16,2,3,0,4.19A8,8,0,0,1,161.44,349.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M168.71,349.85a8,8,0,0,1-7.27,0l-2.52,1.45a13.6,13.6,0,0,0,12.33,0c3.39-2,3.37-5.15,0-7.12l-2.52,1.46C170.7,346.82,170.71,348.7,168.71,349.85Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "229.91 334.92 172.16 301.58 175.16 299.85 232.9 333.19 229.91 334.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-88",
    points: "211.87 324.5 172.16 301.58 175.16 299.85 214.86 322.77 211.87 324.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "219.92 340.68 162.17 307.34 165.17 305.62 222.91 338.95 219.92 340.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-88",
    points: "208.32 333.99 162.17 307.34 165.17 305.62 211.32 332.26 208.32 333.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "209.93 346.45 152.18 313.11 155.18 311.38 212.92 344.72 209.93 346.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-88",
    points: "184.28 331.64 152.18 313.11 155.18 311.38 187.27 329.91 184.28 331.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "199.94 352.22 142.19 318.88 145.19 317.15 202.93 350.49 199.94 352.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-88",
    points: "193.61 348.57 142.19 318.88 145.19 317.15 196.61 346.84 193.61 348.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M139.39,280.72c-13.71-7.92-35.87-8-49.49-.09s-13.56,20.66.15,28.57,35.87,8,49.5.09S153.1,288.63,139.39,280.72ZM92.18,308c-12.53-7.24-12.6-18.93-.14-26.12s32.7-7.15,45.23.08,12.59,18.93.14,26.12S104.71,315.21,92.18,308Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M88.93,309.74c.55.32,1.11.62,1.68.91l2-1.33,0,0c-.52-.26-1-.54-1.53-.83C83.37,304,80.2,297.84,81.65,292l-3.09-.36C76.93,298.06,80.38,304.81,88.93,309.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M135.79,312.12a37.19,37.19,0,0,0,4.7-2.29,23.83,23.83,0,0,0,8.36-7.54l-3-.56a21.89,21.89,0,0,1-7.6,6.82,36.13,36.13,0,0,1-4.42,2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M108.53,274.13l.41,1.8c10.27-1,21.21.82,29.17,5.41a27.75,27.75,0,0,1,3.63,2.48l2.54-1.06a31.45,31.45,0,0,0-4-2.69C131.65,275.06,119.74,273.08,108.53,274.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M127.21,302.17c-7,4-18.29,4-25.3-.05s-7-10.58-.08-14.6,18.29-4,25.3,0S134.18,298.15,127.21,302.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M131.31,285.15c-9.33-5.39-24.41-5.42-33.69-.06s-9.22,14.06.11,19.45,24.41,5.41,33.69.06S140.64,290.54,131.31,285.15ZM100.41,303c-7.84-4.53-7.88-11.85-.09-16.35s20.47-4.47,28.31.06,7.88,11.84.09,16.34S108.25,307.52,100.41,303Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-94"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M133.54,305.83a20.58,20.58,0,0,0,4.14-3.09,1.28,1.28,0,0,0,.85-.1.35.35,0,0,0,0-.66,1.27,1.27,0,0,0-1.14,0c-.31.18-.31.47,0,.65l0,0a20.44,20.44,0,0,1-4.1,3c-9.25,5.35-23.93,5.94-34.45,1.47.15-.17.1-.39-.15-.54a1.25,1.25,0,0,0-1.13,0c-.31.18-.31.47,0,.66a1.27,1.27,0,0,0,1.11,0C109.37,311.83,124.2,311.22,133.54,305.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M140.21,298.82a1.08,1.08,0,0,0-.65.13.34.34,0,0,0,0,.65,1.27,1.27,0,0,0,1.14,0c.31-.18.31-.47,0-.65a.73.73,0,0,0-.22-.09c2.41-5.33-.25-11-7-14.94a32.11,32.11,0,0,0-7.4-3c0-.14,0-.29-.22-.4a1.27,1.27,0,0,0-1.14,0c-.31.18-.31.47,0,.65a1.25,1.25,0,0,0,1.13,0,.45.45,0,0,0,.13-.1,31.61,31.61,0,0,1,7.29,3C140,287.92,142.59,293.54,140.21,298.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M92.72,286.07l0,0a22.4,22.4,0,0,1,3-2.07c6.17-3.56,14.89-5.12,23.47-4.21a.41.41,0,0,0,.24.34,1.25,1.25,0,0,0,1.13,0,.34.34,0,0,0,0-.65,1.27,1.27,0,0,0-1.14,0,.59.59,0,0,0-.18.17c-8.67-.92-17.48.65-23.71,4.24a22.4,22.4,0,0,0-3,2.11,1.23,1.23,0,0,0-.85.11.34.34,0,0,0,0,.65,1.25,1.25,0,0,0,1.13,0C93,286.54,93,286.25,92.72,286.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M88.39,294.29a1,1,0,0,0-.4-.12,10,10,0,0,1,1.66-4.8,1.19,1.19,0,0,0,.73-.13c.31-.18.31-.47,0-.65a1.25,1.25,0,0,0-1.13,0,.34.34,0,0,0,0,.65l.16.07a10,10,0,0,0-1.68,4.85,1.12,1.12,0,0,0-.46.13.34.34,0,0,0,0,.65,1.24,1.24,0,0,0,1.14,0A.35.35,0,0,0,88.39,294.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M95.17,304.7a1.32,1.32,0,0,0-1-.07c-3.29-2.27-5.36-5-6-7.92a1,1,0,0,0,.34-.12c.31-.18.31-.47,0-.65a1.25,1.25,0,0,0-1.13,0,.34.34,0,0,0,0,.65,1.12,1.12,0,0,0,.52.14c.66,3,2.75,5.71,6.08,8-.26.18-.25.45.05.62a1.25,1.25,0,0,0,1.13,0A.35.35,0,0,0,95.17,304.7Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-94"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M87.27,288.27a.52.52,0,0,0-.15-.07,20.13,20.13,0,0,1,6.38-5.5,32.33,32.33,0,0,1,4-1.92h0a1.25,1.25,0,0,0,1.13,0,.34.34,0,0,0,0-.65,1.27,1.27,0,0,0-1.14,0c-.24.14-.29.34-.15.51a33.14,33.14,0,0,0-4,1.94,20.22,20.22,0,0,0-6.43,5.55,1.26,1.26,0,0,0-.73.12.35.35,0,0,0,0,.66,1.25,1.25,0,0,0,1.13,0C87.59,288.74,87.59,288.45,87.27,288.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M102,279.38a1.25,1.25,0,0,0,1.13,0c.2-.12.27-.28.21-.43,11.06-2.57,23.58-1.1,32.1,3.82a21.75,21.75,0,0,1,5.59,4.47l-.2.08c-.32.18-.32.47,0,.65a1.22,1.22,0,0,0,1.13,0,.35.35,0,0,0,0-.66,1.32,1.32,0,0,0-.67-.13,22,22,0,0,0-5.66-4.53,40.5,40.5,0,0,0-15.83-4.81,50.5,50.5,0,0,0-16.56.95l-.11-.08a1.25,1.25,0,0,0-1.13,0C101.65,278.91,101.66,279.2,102,279.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M136.56,305.73a.35.35,0,0,0,0,.66,1.27,1.27,0,0,0,1.14,0c.28-.16.3-.42.07-.6,5.63-4,7.85-9.31,6-14.39l.26-.1a.35.35,0,0,0,0-.66,1.25,1.25,0,0,0-1.13,0c-.32.18-.32.47,0,.65a1.16,1.16,0,0,0,.6.14c1.82,5-.38,10.29-6,14.25A1.31,1.31,0,0,0,136.56,305.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M134.12,307.8a1.25,1.25,0,0,0-1.13,0c-.26.15-.3.38-.13.55a43.25,43.25,0,0,1-15.73,3.55.48.48,0,0,0-.2-.2,1.24,1.24,0,0,0-1.14,0,.35.35,0,0,0,0,.66,1.25,1.25,0,0,0,1.13,0,.44.44,0,0,0,.23-.29A44,44,0,0,0,133,308.47a1.28,1.28,0,0,0,1.1,0C134.44,308.27,134.44,308,134.12,307.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M86.11,298.38a1.21,1.21,0,0,0-.6-.14,10.18,10.18,0,0,1,.06-7.17,1.22,1.22,0,0,0,.61-.13c.31-.18.31-.47,0-.66a1.27,1.27,0,0,0-1.14,0c-.31.18-.31.47,0,.66a.92.92,0,0,0,.25.09,10.26,10.26,0,0,0-.06,7.24,1.57,1.57,0,0,0-.26.1.35.35,0,0,0,0,.66,1.25,1.25,0,0,0,1.13,0A.34.34,0,0,0,86.11,298.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M112.69,311.64a1.25,1.25,0,0,0-1.13,0,.48.48,0,0,0-.2.2,41.56,41.56,0,0,1-17.73-4.94,20.16,20.16,0,0,1-6.58-5.73l.17-.07c.31-.18.31-.47,0-.66a1.25,1.25,0,0,0-1.13,0,.35.35,0,0,0,0,.66,1.29,1.29,0,0,0,.71.13A20.42,20.42,0,0,0,93.43,307a41.88,41.88,0,0,0,17.9,5,.44.44,0,0,0,.23.29,1.27,1.27,0,0,0,1.14,0C113,312.11,113,311.82,112.69,311.64Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-94"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M143.15,311.37a29.88,29.88,0,0,0,6.18-4.61,1.91,1.91,0,0,0,1.34-.13.52.52,0,0,0,0-1,1.89,1.89,0,0,0-1.7,0,.52.52,0,0,0,0,1l.13.07a31.07,31.07,0,0,1-6.14,4.58c-13.88,8-35.89,8.91-51.69,2.2.28-.26.22-.61-.18-.84a1.89,1.89,0,0,0-1.7,0,.52.52,0,0,0,0,1,1.89,1.89,0,0,0,1.7,0l0,0C107,320.34,129.18,319.44,143.15,311.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M153.26,300.91a1.87,1.87,0,0,0-1,.19.52.52,0,0,0,0,1,1.89,1.89,0,0,0,1.7,0c.47-.27.46-.7,0-1a1.58,1.58,0,0,0-.4-.15c3.6-8-.38-16.45-10.53-22.32a47.88,47.88,0,0,0-11-4.53c.09-.22,0-.46-.32-.64a1.89,1.89,0,0,0-1.7,0,.52.52,0,0,0,0,1,1.86,1.86,0,0,0,1.69,0,.75.75,0,0,0,.23-.19,47,47,0,0,1,10.94,4.49C152.88,284.57,156.83,293,153.26,300.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M82.07,281.82l-.13-.07a33.73,33.73,0,0,1,4.51-3.11c9.25-5.34,22.33-7.67,35.21-6.31a.58.58,0,0,0,.35.55,1.86,1.86,0,0,0,1.69,0,.52.52,0,0,0,0-1,1.89,1.89,0,0,0-1.7,0,.78.78,0,0,0-.29.28c-13-1.37-26.13,1-35.44,6.35a33,33,0,0,0-4.56,3.15,1.86,1.86,0,0,0-1.34.13.52.52,0,0,0,0,1,1.89,1.89,0,0,0,1.7,0A.52.52,0,0,0,82.07,281.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M75.59,294.13a1.63,1.63,0,0,0-.68-.19,14.7,14.7,0,0,1,2.49-7.19,1.88,1.88,0,0,0,1.16-.18c.47-.27.46-.71,0-1a1.86,1.86,0,0,0-1.69,0,.52.52,0,0,0,0,1,1.34,1.34,0,0,0,.3.12,15,15,0,0,0-2.52,7.24,1.81,1.81,0,0,0-.75.2.52.52,0,0,0,0,1,1.89,1.89,0,0,0,1.7,0A.52.52,0,0,0,75.59,294.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M85.74,309.72a1.89,1.89,0,0,0-1.53-.08c-4.94-3.4-8-7.48-9-11.88a1.77,1.77,0,0,0,.59-.18c.47-.27.46-.71,0-1a1.86,1.86,0,0,0-1.69,0c-.47.27-.47.7,0,1a1.84,1.84,0,0,0,.85.2c1,4.43,4.1,8.53,9.07,12-.43.27-.43.69,0,1a1.89,1.89,0,0,0,1.7,0A.52.52,0,0,0,85.74,309.72Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-88",
    points: "239.49 122.87 155.66 74.47 155.66 30.55 239.49 78.95 239.49 122.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M150.32,23V75.89l94.51,54.56V77.53ZM242,126.58,153.12,75.24V26.84L242,78.18Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-94"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M213.07,56.12a1.65,1.65,0,0,0,.76,1c.42.24.77.14.77-.22a1.52,1.52,0,0,0-.77-1.11c-.38-.22-.69-.17-.76.09L172.65,32.52a1.64,1.64,0,0,0-.75-1c-.43-.25-.78-.15-.78.22a1.53,1.53,0,0,0,.78,1.11c.37.21.68.16.75-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M167.89,88.57c-.38-.21-.69-.16-.76.1L146.65,76.84V65.26c.35.14.61,0,.61-.3a1.5,1.5,0,0,0-.77-1.1c-.42-.25-.77-.15-.77.21a1.45,1.45,0,0,0,.62,1V76.93l20.79,12a1.62,1.62,0,0,0,.76,1c.42.25.77.15.77-.22A1.56,1.56,0,0,0,167.89,88.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M193.81,103.54c-.37-.22-.68-.17-.76.09L174.5,92.92a1.62,1.62,0,0,0-.75-1c-.43-.25-.78-.15-.78.21a1.51,1.51,0,0,0,.78,1.11c.37.22.68.17.75-.09l18.55,10.71a1.73,1.73,0,0,0,.76,1c.42.24.77.14.77-.22A1.54,1.54,0,0,0,193.81,103.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M227.08,122.75c-.37-.22-.68-.17-.75.09l-24.29-14a1.62,1.62,0,0,0-.75-1c-.43-.25-.78-.15-.78.21a1.51,1.51,0,0,0,.78,1.11c.37.22.68.17.75-.09l24.29,14a1.67,1.67,0,0,0,.75,1c.43.24.77.14.77-.22A1.51,1.51,0,0,0,227.08,122.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M248.66,114.89c-.42-.25-.77-.15-.77.21a1.47,1.47,0,0,0,.62,1v19.54l-14.34-8.28v.27l14.65,8.46V116.29c.35.14.62,0,.62-.3A1.51,1.51,0,0,0,248.66,114.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M249.44,96.36a1.53,1.53,0,0,0-.78-1.11c-.42-.25-.77-.15-.77.22a1.45,1.45,0,0,0,.62,1v13c-.35-.14-.62,0-.62.3a1.56,1.56,0,0,0,.77,1.11c.43.24.78.14.78-.22a1.49,1.49,0,0,0-.62-1v-13C249.17,96.79,249.44,96.68,249.44,96.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M219.37,60.29c.38.21.69.17.76-.1l28.38,16.39V90.13c-.35-.14-.62,0-.62.3a1.56,1.56,0,0,0,.77,1.11c.43.24.78.14.78-.22a1.49,1.49,0,0,0-.62-1V76.49L220.13,59.93a1.65,1.65,0,0,0-.76-1c-.42-.24-.77-.15-.77.22A1.54,1.54,0,0,0,219.37,60.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M146.49,28.3c.43.25.77.15.77-.22a1.44,1.44,0,0,0-.61-1V17.77L165.9,28.88a1.61,1.61,0,0,0,.75,1c.43.25.77.15.77-.22a1.53,1.53,0,0,0-.77-1.11c-.37-.21-.68-.16-.75.1L146.34,17.33V26.9c-.35-.14-.62,0-.62.29A1.52,1.52,0,0,0,146.49,28.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M145.72,56.91a1.54,1.54,0,0,0,.77,1.11c.43.25.77.15.77-.22a1.36,1.36,0,0,0-.49-.9V33.46c.29.07.49-.05.49-.34a1.5,1.5,0,0,0-.77-1.1c-.42-.25-.77-.15-.77.21a1.38,1.38,0,0,0,.5.91V56.58C145.93,56.51,145.72,56.63,145.72,56.91Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M120.75,83.78v19.45l22.6,13V96.83Zm21.19,30.46-19.77-11.41v-17l19.77,11.42Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-89"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M132.05,93.93c-3.91-2.26-7.08-1.36-7.08,2s3.17,7.93,7.08,10.19,7.09,1.36,7.09-2S136,96.19,132.05,93.93Zm0,11c-3.15-1.83-5.71-5.51-5.71-8.22s2.56-3.44,5.71-1.62,5.72,5.5,5.72,8.22S135.21,106.77,132.05,105Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M132.05,96.17c-2.47-1.42-4.47-.85-4.47,1.27s2,5,4.47,6.44,4.48.86,4.48-1.27S134.53,97.6,132.05,96.17Zm0,6.56c-1.73-1-3.13-3-3.13-4.51s1.4-1.89,3.13-.89,3.14,3,3.14,4.51S133.78,103.72,132.05,102.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M133.93,101.11c0,.89-.84,1.13-1.88.53a3.71,3.71,0,0,1-1.87-2.7c0-.89.84-1.13,1.87-.53A3.71,3.71,0,0,1,133.93,101.11Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "121.3 121.62 142.81 134.04 142.81 120.4 121.3 107.98 121.3 121.62"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-95"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M127.94,121.35V116c0-1.07.83-1.13,2.48-.17s2.44,1.93,2.44,3v5.31c0,.48-.23.71-.69.71a3.75,3.75,0,0,1-1.76-.63,6.94,6.94,0,0,1-1.79-1.41A2.3,2.3,0,0,1,127.94,121.35Zm2.81,1.71v-5.62c0-.17-.12-.32-.34-.45s-.36-.12-.36,0v5.63q0,.24.36.45C130.63,123.24,130.75,123.23,130.75,123.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M136.17,127.52l-2.11-1.22v-6l-.8-.47v-1.2a.8.8,0,0,0,.77.11.52.52,0,0,0,.32-.48l1.82,1.05Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M164.44,109v19.45L187,141.5V122.05Zm21.18,30.46-19.77-11.41V111l19.77,11.42Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-89"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M178.13,121.15c-2.46-2.92-4.65-2.79-4.9-2.77a1.75,1.75,0,0,0-1.74,1.64c-.13,1.49,1.17,3.78,1.17,3.78l.36.79a4.69,4.69,0,0,1,.28.88,5,5,0,0,0,.37,1.43l.12.2,4,2.29c.31-.18.29-.55.37-.94a1.94,1.94,0,0,1,.67-1,9.87,9.87,0,0,0,1-1.15C180,126,180.59,124.07,178.13,121.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M174,127.49v.24a.44.44,0,0,0,.2.33l3.09,1.78c.11.06.2,0,.2-.09v-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M177.29,130.38c0,.05,0,.06-.08,0l-3-1.71a.16.16,0,0,1-.08-.12v-.28s0-.06.08,0l3,1.7a.18.18,0,0,1,.08.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M177.29,131s0,.06-.08,0l-3-1.7a.16.16,0,0,1-.08-.12v-.28s0-.06.08,0l3,1.71a.16.16,0,0,1,.08.12Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-90",
    points: "175.14 130.69 176.33 131.38 176.44 131.35 177.14 131.19 175.74 130.38 174.33 129.57 175.03 130.54 175.14 130.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M175.74,131.42c.31.18.56.22.56.09l-1.13-.65C175.17,131,175.42,131.23,175.74,131.42Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "164.98 146.84 186.49 159.26 186.49 145.62 164.98 133.2 164.98 146.84"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-95"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M170.69,146v-5.31c0-1.07.82-1.13,2.48-.17s2.43,1.93,2.43,3v5.31c0,.48-.23.71-.68.71a3.78,3.78,0,0,1-1.77-.63,7.12,7.12,0,0,1-1.79-1.41A2.33,2.33,0,0,1,170.69,146Zm2.81,1.71v-5.62c0-.17-.12-.32-.35-.45s-.36-.12-.36,0v5.63q0,.24.36.45C173.38,147.92,173.5,147.91,173.5,147.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M180.79,153.28,176,150.5v-1.09l2.37-2.38a2.1,2.1,0,0,0,.38-1.45.87.87,0,0,0-.42-.8c-.3-.17-.45-.13-.45.1v1.41L176,145.2v-1.44c0-1.06.79-1.13,2.38-.22a5.13,5.13,0,0,1,1.95,1.71,4.51,4.51,0,0,1,.48,2.2,1,1,0,0,1-.21.74l-2.37,2.54,2.58,1.49Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "252.35 197.28 273.86 209.71 273.86 196.06 252.35 183.64 252.35 197.28"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-95"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M257.54,196.18v-5.31q0-1.6,2.49-.18t2.43,3V199c0,.48-.23.71-.68.71a3.78,3.78,0,0,1-1.77-.63,7.14,7.14,0,0,1-1.79-1.42A2.33,2.33,0,0,1,257.54,196.18Zm2.81,1.71v-5.63c0-.16-.11-.31-.34-.44s-.36-.13-.36,0v5.62c0,.17.12.32.36.46S260.35,198.06,260.35,197.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M268.66,203l-1-.6v1.06l-2.05-1.19v-1.06l-2.85-1.64v-1.17l2.06-4.83,2.84,1.63v6l1,.6Zm-3.09-3v-3.26l-1,2.7Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M251.8,159.44v19.45l22.6,13.05V172.49ZM273,189.91l-19.77-11.42v-17L273,172.89Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-89"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M265.74,174.43c-1.39-.8-2.52-.48-2.52.71a5,5,0,0,0,2.52,3.62c1.39.8,2.51.48,2.51-.71A5,5,0,0,0,265.74,174.43Zm0,3.62a3.34,3.34,0,0,1-1.7-2.43c0-.81.76-1,1.7-.48a3.35,3.35,0,0,1,1.69,2.43C267.43,178.38,266.67,178.59,265.74,178.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M270.6,178.9a.58.58,0,0,0-.3-.42l-.82-.48a5.6,5.6,0,0,0-.48-1.26l.58-.17c.12,0,.12-.19,0-.36l-.82-1.18a.48.48,0,0,0-.42-.24l-.58.17a8.4,8.4,0,0,0-1.15-1.08v-.71a.57.57,0,0,0-.29-.42l-1.16-.67c-.17-.09-.3-.06-.3.08v.71a3.46,3.46,0,0,0-1.15-.25l-.58-.84c-.12-.16-.3-.27-.42-.24l-.82.23c-.11,0-.11.2,0,.36l.58.84a1.45,1.45,0,0,0-.48.71l-.82-.47c-.16-.1-.29-.06-.29.08v1a.6.6,0,0,0,.29.43l.82.47a5.85,5.85,0,0,0,.48,1.27l-.58.16c-.11,0-.11.19,0,.36l.82,1.18c.12.16.3.27.42.24l.58-.16a9,9,0,0,0,1.15,1.07V180a.58.58,0,0,0,.3.42l1.16.67c.16.1.29.06.29-.08v-.71a3.83,3.83,0,0,0,1.15.26l.58.83a.48.48,0,0,0,.42.24l.82-.23c.12,0,.12-.2,0-.36l-.58-.84a1.45,1.45,0,0,0,.48-.71l.82.47c.16.1.3.06.3-.08Zm-4.86.31c-1.68-1-3-2.92-3-4.37s1.36-1.83,3-.86,3,2.92,3,4.37S267.42,180.18,265.74,179.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M259.55,174.14c-.92-.81-1.92-1-2.25-.39s.14,1.73,1.06,2.54,1.91,1,2.24.39S260.46,175,259.55,174.14Zm.51,2.06c-.22.4-.9.28-1.51-.26s-.93-1.31-.71-1.71.9-.28,1.51.26S260.28,175.8,260.06,176.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M262.15,177.5l-.54-.48a2,2,0,0,0,0-.77l.52.09c.1,0,.15-.06.1-.18l-.34-.83a.41.41,0,0,0-.28-.24l-.52-.09a5.78,5.78,0,0,0-.64-.88l.19-.35c0-.07,0-.2-.12-.3l-.76-.67c-.11-.1-.23-.12-.26-.05l-.2.35a4.32,4.32,0,0,0-.87-.46l-.24-.59a.43.43,0,0,0-.28-.25l-.73-.12c-.1,0-.15.06-.1.18l.25.59a1.13,1.13,0,0,0-.59.21l-.54-.48c-.1-.09-.22-.11-.26,0l-.28.49a.31.31,0,0,0,.13.3l.54.48a2,2,0,0,0,0,.77l-.52-.09c-.1,0-.15.06-.1.18l.34.83a.41.41,0,0,0,.28.24l.52.09a5.78,5.78,0,0,0,.64.88l-.19.35c0,.07,0,.2.12.3l.76.67c.11.1.23.12.27.05l.19-.35a4.32,4.32,0,0,0,.87.46l.24.59a.43.43,0,0,0,.28.25l.73.12c.1,0,.15-.06.1-.18l-.25-.59a1.13,1.13,0,0,0,.59-.21l.54.48c.11.09.22.11.26,0l.28-.49C262.32,177.73,262.26,177.59,262.15,177.5ZM261,177c-.4.72-1.62.51-2.72-.46s-1.67-2.36-1.27-3.07,1.61-.51,2.71.46S261.34,176.27,261,177Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M208.12,134.22v19.45l22.6,13.05V147.27Zm21.19,30.47-19.78-11.42v-17l19.78,11.42Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-89"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M219.42,150.4c1.88,1.09,3.41.59,3.41-1.1s-1.53-4-3.41-5-3.41-.6-3.41,1.1S217.54,149.31,219.42,150.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M226,158.48s0-.1,0-.16c-.47-2.15-2.66-4.84-5.31-6.37l-2.54-1.47c-2.65-1.53-4.84-1.37-5.31.25a1,1,0,0,0,0,.1l-.47,1.76L215,154.1l.35-1.3.58.34v1.49l7.08,4.1v-1.5l.58.33.35,1.7,2.62,1.51Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "208.66 172.06 230.18 184.49 230.18 170.84 208.66 158.42 208.66 172.06"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-95"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M214.38,171.26V166c0-1.08.83-1.13,2.48-.18s2.44,1.94,2.44,3v5.32a.62.62,0,0,1-.69.71,3.87,3.87,0,0,1-1.76-.63,7,7,0,0,1-1.79-1.42A2.33,2.33,0,0,1,214.38,171.26Zm2.81,1.71v-5.63c0-.16-.11-.31-.34-.44s-.36-.13-.36,0v5.62c0,.17.12.32.36.46S217.19,173.13,217.19,173Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M219.68,172.27l1.93,1.12v2a.63.63,0,0,0,.38.53c.26.15.38.12.38-.09v-1.91a.8.8,0,0,0-.19-.55,2.42,2.42,0,0,0-.71-.53v-.94c.6.35.9.36.9,0v-1.46c0-.17-.12-.32-.38-.47s-.39-.14-.39,0v1.52l-1.87-1.08v-1.53c0-1,.79-1,2.35-.1a6.82,6.82,0,0,1,1.65,1.3,2.28,2.28,0,0,1,.7,1.51v1.14c0,.66-.37.89-1.09.7a2.76,2.76,0,0,1,1.12,2.18v1.23c0,1.14-.79,1.26-2.37.35s-2.41-1.92-2.41-3Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-94"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M132.23,85.67V80.51l-.35-.2v5.16c-.31-.11-.54,0-.54.28a1.39,1.39,0,0,0,.71,1c.4.23.71.14.71-.2A1.33,1.33,0,0,0,132.23,85.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M175.91,110.89v-5.16l-.35-.19v5.15c-.3-.11-.54,0-.54.28a1.38,1.38,0,0,0,.72,1c.39.23.71.14.71-.2A1.31,1.31,0,0,0,175.91,110.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M263.28,161.33v-5.15l-.35-.2v5.15c-.31-.11-.54,0-.54.28a1.39,1.39,0,0,0,.71,1c.4.23.72.14.72-.2A1.33,1.33,0,0,0,263.28,161.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M219.59,136.11V131l-.34-.19v5.15c-.31-.11-.54,0-.54.28a1.39,1.39,0,0,0,.71,1c.39.23.71.14.71-.2A1.33,1.33,0,0,0,219.59,136.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M219.42,130.86c.33.19.61.15.69-.07l42.31,24.42a1.51,1.51,0,0,0,.68.87c.4.22.72.13.72-.21a1.41,1.41,0,0,0-.72-1c-.33-.19-.61-.15-.68.07l-42.31-24.43a1.55,1.55,0,0,0-.69-.86c-.33-.19-.61-.15-.69.07l-20.46-11.82a1.58,1.58,0,0,0-.52-.74v-10c.34.13.6,0,.6-.3a1.52,1.52,0,0,0-.77-1.1c-.43-.25-.77-.15-.77.21a1.44,1.44,0,0,0,.6,1v10c-.26-.09-.46,0-.52.15l-20.47-11.82a1.49,1.49,0,0,0-.68-.86c-.34-.19-.61-.15-.69.07L132.74,80.05a1.51,1.51,0,0,0-.69-.86c-.39-.23-.71-.14-.71.2a1.39,1.39,0,0,0,.71,1c.34.2.61.16.69-.06l42.31,24.42a1.51,1.51,0,0,0,.69.86c.33.2.61.16.68-.06l20.47,11.81a1.6,1.6,0,0,0,.69.87c.33.19.61.15.69-.07L218.73,130A1.6,1.6,0,0,0,219.42,130.86Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M351.29,326.05a17.78,17.78,0,0,0-12-1.51l-17.55-10.13-2.56,6.09,13.56,7.82c-1.51,2.33-.65,5.06,2.61,6.93,4.43,2.56,11.59,2.58,16,0S355.72,328.61,351.29,326.05Zm-13.85,8c-3.26-1.89-3.28-4.94,0-6.81a13,13,0,0,1,11.79,0c3.27,1.88,3.28,4.93,0,6.81A13.08,13.08,0,0,1,337.44,334.05Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-89"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M341.81,334.25l-1.69-1,1.79-1.37-.76-.44-2.37,1-1.7-1,9-3.73,2.17,1.25Zm1-3,2.06-1.48-2.54,1.2Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M344.82,339.65a17.81,17.81,0,0,0-12-1.51l-16.93-9.78-.49,1.16-2.07,4.93,12.94,7.47c-1.51,2.32-.64,5.05,2.61,6.93,4.43,2.56,11.59,2.57,16,0S349.25,342.2,344.82,339.65Zm-13.85,8c-3.27-1.88-3.29-4.93,0-6.81a13,13,0,0,1,11.79,0c3.27,1.88,3.29,4.93,0,6.8A13,13,0,0,1,331,347.64Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-89"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M331,345.37l7.75-4.47,2,1.16a2,2,0,0,1,.93.92c.14.33,0,.63-.51.91l-1.07.62a2.79,2.79,0,0,1-2.16.09c.53.5.51.92-.06,1.25l-1.5.87a2.79,2.79,0,0,1-1.65.37,3.84,3.84,0,0,1-1.58-.47Zm7.22-1.64,1.32-.76c.27-.15.24-.32-.07-.51l-2.14,1.24A.84.84,0,0,0,338.26,343.73Zm-3.62,2.1,2-1.14c.27-.15.24-.32-.08-.51l-2.77,1.61A.87.87,0,0,0,334.64,345.83Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M338.39,353.27a17.81,17.81,0,0,0-12-1.51L310,342.31l-2.55,6.09,12.37,7.15c-1.51,2.32-.64,5.05,2.61,6.93,4.43,2.56,11.6,2.57,16,0S342.82,355.83,338.39,353.27Zm-13.85,8c-3.27-1.89-3.29-4.94,0-6.81a13,13,0,0,1,11.79,0c3.27,1.89,3.29,4.94,0,6.81A13.06,13.06,0,0,1,324.54,361.27Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-89"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M333.46,358.28l-1.56-.89,1.54-.89c.12-.07.11-.15-.05-.25a.44.44,0,0,0-.44,0l-5.37,3.1c-.13.08-.11.16.06.26a.38.38,0,0,0,.42,0l1.91-1.1,1.56.9-2,1.13a2.2,2.2,0,0,1-1.42.2,4.23,4.23,0,0,1-1.56-.52c-1.32-.76-1.52-1.41-.59-1.95l5-2.87a3.32,3.32,0,0,1,3.48.27c1.18.68,1.32,1.28.4,1.81Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "315.77 310.76 307.42 330.64 299.07 350.52 272.99 335.46 246.91 320.41 281.34 315.59 315.77 310.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-88",
    points: "286.08 312.59 273.28 314.38 309.5 335.3 312.6 327.91 313.39 326.03 289.33 312.14 286.08 312.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-88",
    points: "314.57 323.22 321.09 307.69 294.19 311.46 314.57 323.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-88",
    points: "268.42 315.06 251.06 317.5 277.59 332.81 304.11 348.12 308.32 338.1 268.42 315.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M384.65,238,321.57,201.6c-2.45-1.41-4.43-5.2-4.43-8.47V166.89c0-3.26,2-4.76,4.43-3.35L384.65,200c2.44,1.41,4.43,5.2,4.43,8.46v26.25C389.08,237.93,387.09,239.43,384.65,238Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "382.95 220.53 323.26 186.07 323.26 181.16 382.95 215.62 382.95 220.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "382.95 230.83 323.26 196.37 323.26 191.46 382.95 225.92 382.95 230.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-88",
    points: "344.19 198.16 323.26 186.07 323.26 181.16 344.19 193.24 344.19 198.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-88",
    points: "362.91 219.26 323.26 196.37 323.26 191.46 362.91 214.34 362.91 219.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "382.95 208.59 341.48 184.64 341.48 182.19 382.95 206.13 382.95 208.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M327.53,175.36c0,1.2-.85,1.68-1.89,1.08a4.17,4.17,0,0,1-1.89-3.27c0-1.19.84-1.68,1.89-1.07A4.17,4.17,0,0,1,327.53,175.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M333.33,178.71c0,1.19-.85,1.68-1.89,1.07a4.14,4.14,0,0,1-1.89-3.26c0-1.19.84-1.68,1.89-1.07A4.17,4.17,0,0,1,333.33,178.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M339.13,182.06c0,1.19-.85,1.68-1.89,1.07a4.14,4.14,0,0,1-1.89-3.26c0-1.19.84-1.68,1.89-1.07A4.17,4.17,0,0,1,339.13,182.06Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtivo4);
export default __webpack_public_path__ + "static/media/Ativo 4.c8873a2959960c10b1df8dbf8b15a367.svg";
export { ForwardRef as ReactComponent };